var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyQuizQuestions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 9.6665C10.5621 9.6665 9.66666 10.5619 9.66666 11.6665V52.3332C9.66666 53.4377 10.5621 54.3332 11.6667 54.3332H52.3333C53.4379 54.3332 54.3333 53.4377 54.3333 52.3332V31.9998H52.3333V52.3332H11.6667V11.6665H32V9.6665H11.6667ZM50.4865 12.7878C48.5338 10.8352 45.368 10.8352 43.4154 12.7878L23.2628 32.9404C23.116 33.0872 23.0185 33.2762 22.9839 33.481L21.4518 42.5555C21.3979 42.8747 21.5019 43.2002 21.7308 43.4291C21.9597 43.658 22.2852 43.7619 22.6044 43.7081L31.6789 42.176C31.8837 42.1414 32.0727 42.0439 32.2195 41.8971L52.3721 21.7445C54.3247 19.7919 54.3247 16.6261 52.3721 14.6734L50.4865 12.7878ZM44.8296 14.202C46.0012 13.0305 47.9007 13.0305 49.0722 14.202L50.9579 16.0877C52.1294 17.2592 52.1294 19.1587 50.9579 20.3303L31.0311 40.2571L23.658 41.5019L24.9028 34.1288L44.8296 14.202Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyQuizQuestions);
export default __webpack_public_path__ + "static/media/emptyQuizQuestions.8f1e0ed3.svg";
export { ForwardRef as ReactComponent };